// App shell + router (handoff 4). SPA, basename /feedback.
// Routes: / (invite), /list, /new (compose), /:id (detail), * (in-app 404).
// Every route renders its own AppBar (per-screen title/back) so the bar updates
// instantly on navigation; only the main content section animates in on mount.

import type { ReactNode } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Invite } from './routes/Invite';
import { List } from './routes/List';
import { Compose } from './routes/Compose';
import { Detail } from './routes/Detail';
import { NotFound } from './routes/NotFound';
import { Cooperate } from './routes/Cooperate';
import { getSession } from './lib/session';

function RequireSession({ children }: { children: ReactNode }) {
  const loc = useLocation();
  if (!getSession()) {
    return <Navigate to="/" replace state={{ from: loc.pathname }} />;
  }
  return <>{children}</>;
}

export function App() {
  return (
    <BrowserRouter basename="/feedback">
      <div className="app-shell">
        <Routes>
          <Route path="/" element={<Invite />} />
          <Route path="/cooperate" element={<Cooperate />} />
          <Route path="/list" element={<RequireSession><List /></RequireSession>} />
          <Route path="/new" element={<RequireSession><Compose /></RequireSession>} />
          <Route path="/:id" element={<RequireSession><Detail /></RequireSession>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
